/**
 * /ti/s/:code — physical bin QR deep-link redirect.
 * Resolves the bin code → /ti/hub?tab=<zone>&scan=<code>.
 * Mirrors ProductionUnitScanRedirect for KA tote codes.
 */
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { enterStaffPortal } from "@/lib/staffPortal";

const ZONE_PREFIX_MAP = { B: "baking", F: "frosting", D: "decor", P: "packaging" };

function parseBinCode(raw) {
  const text = (raw || "").trim();
  const match = text.toUpperCase().match(/([BFDP])(\d{1,2})/);
  if (match) return `${match[1]}${match[2]}`;
  return text.toUpperCase().slice(0, 10);
}

export default function InventoryScanRedirect() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [err, setErr] = useState("");

  useEffect(() => {
    const parsed = parseBinCode(code || "");
    const prefix = parsed[0] || "";
    const tab = ZONE_PREFIX_MAP[prefix] || "baking";
    const hubUrl = `/ti/hub?tab=${tab}&scan=${parsed}`;
    enterStaffPortal("inventory", "/ti/hub");
    navigate(hubUrl, { replace: true });
  }, [code, navigate]);

  if (err) {
    return (
      <div style={{ padding: 32, textAlign: "center", color: "#EE2677", fontFamily: "sans-serif" }}>
        <p>{err}</p>
      </div>
    );
  }
  return null;
}
